import { Theme } from '@mui/material';

import { TYPOGRAPHY_VARIANTS } from '../typography/typography';

export const getFormGroupStyles = (theme: Theme) => ({
  gap: theme.backrs.spacing['spacing-lg'],
});

export const getFormControlLabelStyles = (theme: Theme, isSelected: boolean | undefined) => ({
  display: 'flex',
  padding: theme.backrs.spacing['spacing-xl'],
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  borderRadius: theme.backrs.radius['radius-xl'],
  outline: isSelected
    ? `2px solid ${theme.backrs.colors['Brand/500']}`
    : `1px solid ${theme.backrs.colors['Colors/Border/border-primary']}`,
  ...TYPOGRAPHY_VARIANTS['text-md-regular'],
  '& .MuiFormControlLabel-label': {
    margin: theme.backrs.spacing['spacing-none'],
  },

  marginLeft: theme.backrs.spacing['spacing-none'],
  marginRight: theme.backrs.spacing['spacing-none'],
});

export const getRadioStyles = (theme: Theme, isSelected: boolean | undefined) => ({
  padding: 0,
  marginRight: theme.backrs.spacing['spacing-lg'],
  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px',
  },
  '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)': {
    color: isSelected ? theme.backrs.colors['Colors/Base/Black'] : theme.backrs.colors['Gray/600'],
    borderRadius: theme.backrs.radius['radius-full'],
    backgroundColor: isSelected ? theme.backrs.colors['Brand/600'] : 'transparent',
    border: `1px solid ${isSelected ? theme.backrs.colors['Colors/Base/Black'] : theme.backrs.colors['Gray/600']}`,
    '& path': {
      fill: isSelected ? theme.backrs.colors['Brand/600'] : 'transparent',
    },
  },
  '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
    color: theme.backrs.colors['Colors/Base/White'],
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

export const getCheckboxStyles = (theme: Theme) => ({
  padding: 0,
  marginRight: theme.backrs.spacing['spacing-md'],
  '& .MuiSvgIcon-root': {
    fontSize: '16px',
    borderRadius: theme.backrs.radius['radius-xs'],
    border: `1px solid ${theme.backrs.colors['Colors/Base/Black']}`,
    backgroundColor: theme.backrs.colors['Brand/500'],
    color: theme.backrs.colors['Colors/Base/White'],
  },
  '&:not(.Mui-checked)': {
    '& .MuiSvgIcon-root': {
      backgroundColor: theme.backrs.colors['Colors/Base/White'],
      color: theme.backrs.colors['Colors/Base/Transparent'],
    },
  },
  '&.MuiCheckbox-root': {
    height: theme.typography['text-md-regular']?.lineHeight || '1.5rem', // we set the height to the line height of the text-md-regular variant so that the checkbox is correctly positioned with the label
  },
});
